import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IndexService } from '../../services';
import { Spinner } from '../../shared/spinner/spinner';
import { DeleteIndexModalComponent } from './delete-index-modal/delete-index-modal';
import { NewIndexModalComponent } from './new-index-modal/new-index-modal';
import { IndexItem } from '../../shared/interfaces';

@Component({
  selector: 'app-index',
  standalone: true,
  imports: [CommonModule, Spinner],
  templateUrl: './index.html',
  styleUrl: './index.scss'
})
export class Index implements OnInit {
  isLoading = signal(true);
  hasError = signal(false);
  loadingMessage = signal('Caricamento indici...');
  private readonly indexService = inject(IndexService);
  private readonly modalService = inject(NgbModal);

  // Signal con i dati della tabella
  indexes = signal<IndexItem[]>([]);

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading.set(true);
    this.hasError.set(false);

    this.indexService.getIndices().subscribe({
      next: (data) => {
        this.indexes.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        console.error('Errore durante il recupero degli indici:', err);
        this.hasError.set(true);
        this.isLoading.set(false);
      }
    });
  }

  openNewIndexModal() {
    const modalRef = this.modalService.open(NewIndexModalComponent, { centered: true });

    modalRef.result.then((result) => {
      if (result === true) {
        console.log('Indice creato con successo');
        this.loadData();
      }
    }).catch(() => { });
  }

  openDeleteModal(item: IndexItem) {
    const modalRef = this.modalService.open(DeleteIndexModalComponent, { centered: true });
    modalRef.componentInstance.indexItem = item;

    modalRef.result.then((result) => {
      if (result === true) {
        console.log(`Indice eliminato`);
        this.loadData();
      }
    }).catch(() => { });
  }
}